export const getComponentName = (componentStack) => {
  return (
   componentStack
     ?.split('\n')?.[1]
     ?.replace(/in/, '')
     ?.trim()
     ?.split(' ')?.[0]
     ?.split(':')?.[0]
  ) || '';
};
